"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.removeMultiSigPayer = exports.getAuthorization = exports.prepareStorage = exports.prepareRemoveMultiSigPayer = void 0;
const internal_1 = require("../../internal");
const types_1 = require("../../types");
const conversion_1 = require("../../utils/conversion");
/**
 * @hidden
 */
function prepareRemoveMultiSigPayer(args) {
    return __awaiter(this, void 0, void 0, function* () {
        const { context: { polymeshApi: { tx }, }, storage: { currentPayer, signingIdentity, isMultiSigSigner }, context, } = this;
        const { multiSig } = args;
        if (!currentPayer) {
            throw new internal_1.PolymeshError({
                code: types_1.ErrorCode.NoDataChange,
                message: 'The multiSig does not have a payer set',
                data: { multiSig: multiSig.address },
            });
        }
        const signingAccount = context.getSigningAccount();
        if (isMultiSigSigner) {
            return {
                transaction: tx.multiSig.removePayer,
                args: undefined,
                resolver: undefined,
            };
        }
        else if (currentPayer.isEqual(signingIdentity)) {
            const rawMultiSigAddress = (0, conversion_1.stringToAccountId)(multiSig.address, context);
            return {
                transaction: tx.multiSig.removePayerViaPayer,
                args: [rawMultiSigAddress],
                resolver: undefined,
            };
        }
        else {
            throw new internal_1.PolymeshError({
                code: types_1.ErrorCode.ValidationError,
                message: "The signing account is not part of the MultiSig nor the payer's identity",
                data: { multiSig: multiSig.address, signingAccount: signingAccount.address },
            });
        }
    });
}
exports.prepareRemoveMultiSigPayer = prepareRemoveMultiSigPayer;
/**
 * @hidden
 */
function prepareStorage(args) {
    return __awaiter(this, void 0, void 0, function* () {
        const { context } = this;
        const { multiSig } = args;
        const [currentPayer, { signers }, signingIdentity, signingAccount] = yield Promise.all([
            multiSig.getPayer(),
            multiSig.details(),
            context.getSigningIdentity(),
            context.getSigningAccount(),
        ]);
        const isMultiSigSigner = signers.some(signer => signer.isEqual(signingAccount));
        return {
            currentPayer,
            signingIdentity,
            isMultiSigSigner,
        };
    });
}
exports.prepareStorage = prepareStorage;
/**
 * @hidden
 */
function getAuthorization() {
    const { storage: { isMultiSigSigner }, } = this;
    const transactions = [];
    if (isMultiSigSigner) {
        transactions.push(types_1.TxTags.multiSig.RemovePayer);
    }
    else {
        transactions.push(types_1.TxTags.multiSig.RemovePayerViaPayer);
    }
    return {
        permissions: {
            transactions,
        },
    };
}
exports.getAuthorization = getAuthorization;
/**
 * @hidden
 */
const removeMultiSigPayer = () => new internal_1.Procedure(prepareRemoveMultiSigPayer, getAuthorization, prepareStorage);
exports.removeMultiSigPayer = removeMultiSigPayer;
//# sourceMappingURL=removeMultiSigPayer.js.map